import { subject } from "@casl/ability";
import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { getGrupoResposta } from "@/modules/diagnosticos/firestore";
import useUserStore from "@/modules/users/store";

type TGetRespostasResponse = Awaited<ReturnType<typeof getGrupoResposta>>;

const QUERY_KEY = "respostas";

/**
 * Get respostas query hook
 * @param root0 - root
 * @param root0.id - id
 * @param root0.empresaProjetoId - empresaProjetoId
 * @returns Respostas query hook
 */
function useQueryRespostasEmpresa({
  id,
  empresaProjetoId
}: {
  id: TQuestionario["id"];
  empresaProjetoId: string | undefined;
}) {
  const { idEmpresa } = useParams<{ idEmpresa: string }>();
  const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);
  const empresaId = empresaProjetoId || activeEmpresaId;

  return useQuery<TGetRespostasResponse, FirestoreError, TResposta[]>({
    queryKey: [QUERY_KEY, empresaId, id, idEmpresa],
    queryFn() {
      if (!idEmpresa || !empresaId) {
        throw new Error("Empresa não selecionada");
      }

      if (!id) {
        throw new Error("Questionario não selecionado");
      }

      return getGrupoResposta(empresaId, id, idEmpresa);
    },
    select(dataResponse) {
      if (dataResponse.empty) {
        return [];
      }
      return dataResponse.docs.map((document_) => subject("TResposta", document_.data()));
    }
  });
}

export default useQueryRespostasEmpresa;
